import apiClient, { ApiResponse } from "./client";
import { config } from "../config";

export interface Award {
	id: string;
	awardNumber: string; // Số quyết định/giấy khen
	cccd: string; // CCCD
	studentId?: string; // Mã sinh viên/học sinh (optional)
	studentName: string; // Họ và tên
	dateOfBirth: string; // Ngày sinh
	placeOfBirth: string; // Nơi sinh
	gender: string; // Giới tính
	ethnicCode: string; // Mã Dân tộc
	ethnicity: string; // Dân tộc
	nationalityCode: string; // Mã quốc tịch
	nationality: string; // quốc tịch
	awardType: string; // Loại khen thưởng
	awardTypeId: string; // ID loại khen thưởng
	title: string; // Danh hiệu/Tên giải thưởng
	level: string; // Cấp (Quốc tịch, Tỉnh/Thành phố, Trường, etc.)
	levelId: string; // ID cấp
	awardDate: string; // Ngày trao
	awardedBy: string; // Cơ quan/Tổ chức trao
	awardedByCode: string; // Mã cơ quan trao
	reason: string; // Lý do khen thưởng
	academicYear?: string; // Năm học (nếu có)
	semester?: string; // Học kỳ (nếu có)
	subject?: string; // Môn học (nếu có)
	competition?: string; // Cuộc thi (nếu có)
	rank?: string; // Xếp hạng (Nhất, Nhì, Ba, etc.)
	signedBy: string; // Người ký
	signerTitle: string; // Chức danh người ký
	validFrom: string; // Hiệu lực từ
	validTo?: string; // Hiệu lực đến (optional)
	notes?: string; // Ghi chú
	status: "valid"; // Trạng thái
	createdAt?: string;
	updatedAt?: string;
}

export interface AwardFilters {
	search?: string;
	awardType?: string;
	level?: string;
	awardDateFrom?: string;
	awardDateTo?: string;
	academicYear?: string;
	status?: "valid" | "revoked" | "expired" | "all";
	page?: number;
	limit?: number;
}

export interface AwardListResponse {
	data: Award[];
	total: number;
	page: number;
	totalPages: number;
	limit: number;
}

export interface BulkImportResponse {
	created: Award[];
	count: number;
	errors?: { row: number; message: string }[];
}

// Mock data for fallback
const mockAwards: Award[] = [
	{
		id: "1",
		awardNumber: "QĐ.2024.HS.001",
		cccd: "123456789020",
		studentId: "HS2024001",
		studentName: "Nguyễn Thị Mai",
		dateOfBirth: "2005-04-12",
		placeOfBirth: "Hà Nội",
		gender: "Nữ",
		ethnicCode: "01",
		ethnicity: "Kinh",
		nationalityCode: "VN",
		nationality: "Việt Nam",
		awardType: "Học sinh giỏi",
		awardTypeId: "01",
		title: "Học sinh giỏi cấp Thành phố",
		level: "Thành phố",
		levelId: "02",
		awardDate: "2024-05-20",
		awardedBy: "Sở Giáo dục và Đào tạo Hà Nội",
		awardedByCode: "SGDDT_HN",
		reason: "Đạt điểm trung bình từ 8.5 trở lên tất cả các môn học",
		academicYear: "2023-2024",
		semester: "Cả năm",
		signedBy: "ThS. Trần Thị Hương",
		signerTitle: "Giám đốc Sở",
		validFrom: "2024-05-20",
		notes: "",
		status: "valid",
		createdAt: "2024-05-20T00:00:00Z",
		updatedAt: "2024-05-20T00:00:00Z",
	},
	{
		id: "2",
		awardNumber: "QĐ.2024.CT.002",
		cccd: "123456789021",
		studentId: "SV2024003",
		studentName: "Lê Minh Đức",
		dateOfBirth: "2001-09-15",
		placeOfBirth: "TP.HCM",
		gender: "Nam",
		ethnicCode: "01",
		ethnicity: "Kinh",
		nationalityCode: "VN",
		nationality: "Việt Nam",
		awardType: "Giải thưởng cuộc thi",
		awardTypeId: "02",
		title: "Giải Nhất Cuộc thi Lập trình ACM",
		level: "Quốc tịch",
		levelId: "01",
		awardDate: "2024-03-10",
		awardedBy: "Hội Tin học Việt Nam",
		awardedByCode: "VVCS",
		reason: "Đạt giải Nhất cuộc thi ACM ICPC Vietnam National Programming Contest",
		competition: "ACM ICPC Vietnam National",
		rank: "Giải Nhất",
		signedBy: "PGS.TS. Nguyễn Thanh Thủy",
		signerTitle: "Chủ tịch Hội",
		validFrom: "2024-03-10",
		notes: "",
		status: "valid",
		createdAt: "2024-03-10T00:00:00Z",
		updatedAt: "2024-03-10T00:00:00Z",
	},
	{
		id: "3",
		awardNumber: "GK.2024.TN.003",
		cccd: "123456789022",
		studentName: "Phạm Thanh Tùng",
		dateOfBirth: "2003-01-08",
		placeOfBirth: "Đà Nẵng",
		gender: "Nam",
		ethnicCode: "01",
		ethnicity: "Kinh",
		nationalityCode: "VN",
		nationality: "Việt Nam",
		awardType: "Giấy khen",
		awardTypeId: "03",
		title: "Sinh viên 5 tốt cấp Trường",
		level: "Trường",
		levelId: "03",
		awardDate: "2024-04-25",
		awardedBy: "Đại học Bách Khoa Đà Nẵng",
		awardedByCode: "DUT",
		reason: "Đạt danh hiệu Sinh viên 5 tốt năm học 2023-2024",
		academicYear: "2023-2024",
		signedBy: "PGS.TS. Lê Văn Sơn",
		signerTitle: "Hiệu trưởng",
		validFrom: "2024-04-25",
		validTo: "2025-04-25",
		notes: "",
		status: "valid",
		createdAt: "2024-04-25T00:00:00Z",
		updatedAt: "2024-04-25T00:00:00Z",
	},
];

export const awardsApi = {
	count: async ()=> {
		return await apiClient.get<number>(`${config.endpoints.scholarships}/count`);
	},
	// Get all awards with optional filters
	getAll: async (filters?: AwardFilters): Promise<ApiResponse<AwardListResponse>> => {
		try {
			const response = await apiClient.get<AwardListResponse>(config.endpoints.awards, filters);
			return response;
		} catch (error) {
			console.error("Error fetching awards:", error);
			// Return mock data as fallback
			const filteredMockData = mockAwards.filter((award) => {
				if (filters?.search) {
					const searchLower = filters.search.toLowerCase();
					const matchesSearch =
						award.studentName.toLowerCase().includes(searchLower) ||
						award.studentId?.toLowerCase().includes(searchLower) ||
						award.awardNumber.toLowerCase().includes(searchLower) ||
						award.cccd.includes(filters.search) ||
						award.title.toLowerCase().includes(searchLower) ||
						award.awardType.toLowerCase().includes(searchLower) ||
						award.awardedBy.toLowerCase().includes(searchLower);
					if (!matchesSearch) return false;
				}

				if (filters?.awardType && filters.awardType !== "all") {
					if (award.awardType !== filters.awardType) return false;
				}

				if (filters?.level && filters.level !== "all") {
					if (award.level !== filters.level) return false;
				}

				if (filters?.awardDateFrom) {
					if (new Date(award.awardDate) < new Date(filters.awardDateFrom)) return false;
				}

				if (filters?.awardDateTo) {
					if (new Date(award.awardDate) > new Date(filters.awardDateTo)) return false;
				}

				if (filters?.academicYear && filters.academicYear !== "all") {
					if (award.academicYear !== filters.academicYear) return false;
				}

				if (filters?.status && filters.status !== "all") {
					if (award.status !== filters.status) return false;
				}

				return true;
			});

			const page = filters?.page || 1;
			const limit = filters?.limit || 10;
			const startIndex = (page - 1) * limit;
			const paginatedData = filteredMockData.slice(startIndex, startIndex + limit);

			return {
				success: true,
				data: {
					data: paginatedData,
					total: filteredMockData.length,
					page,
					totalPages: Math.ceil(filteredMockData.length / limit),
					limit,
				},
			};
		}
	},

	// Get award by ID
	getById: async (id: string): Promise<ApiResponse<Award>> => {
		try {
			const response = await apiClient.get<Award>(`${config.endpoints.awards}/${id}`);
			return response;
		} catch (error) {
			console.error("Error fetching award:", error);
			// Return mock data as fallback
			const mockAward = mockAwards.find((a) => a.id === id);
			if (mockAward) {
				return {
					success: true,
					data: mockAward,
				};
			}
			throw error;
		}
	},

	// Create new award
	create: async (award: Omit<Award, "id" | "createdAt" | "updatedAt">): Promise<ApiResponse<Award>> => {
		try {
			const response = await apiClient.post<Award>(config.endpoints.awards, award);
			return response;
		} catch (error) {
			console.error("Error creating award:", error);
			// Return mock response for demo
			const newAward: Award = {
				...award,
				id: Date.now().toString(),
				createdAt: new Date().toISOString(),
				updatedAt: new Date().toISOString(),
			};
			return {
				success: true,
				data: newAward,
				message: "Tạo khen thưởng thành công",
			};
		}
	},

	// Update award
	update: async (id: string, award: Partial<Award>): Promise<ApiResponse<Award>> => {
		try {
			const response = await apiClient.put<Award>(`${config.endpoints.awards}/${id}`, award);
			return response;
		} catch (error) {
			console.error("Error updating award:", error);
			// Return mock response for demo
			const updatedAward: Award = {
				...mockAwards.find((a) => a.id === id)!,
				...award,
				id,
				updatedAt: new Date().toISOString(),
			};
			return {
				success: true,
				data: updatedAward,
				message: "Cập nhật khen thưởng thành công",
			};
		}
	},

	// Delete award
	delete: async (id: string): Promise<ApiResponse<void>> => {
		try {
			const response = await apiClient.delete<void>(`${config.endpoints.awards}/${id}`);
			return response;
		} catch (error) {
			console.error("Error deleting award:", error);
			// Return success for demo
			return {
				success: true,
				data: undefined,
				message: "Xóa khen thưởng thành công",
			};
		}
	},

	// Bulk import awards
	bulkImport: async (awards: Omit<Award, "id" | "createdAt" | "updatedAt">[]): Promise<ApiResponse<BulkImportResponse>> => {
		try {
			const response = await apiClient.post<BulkImportResponse>(`${config.endpoints.awards}/bulk-import`, { awards });
			return response;
		} catch (error) {
			console.error("Error bulk importing awards:", error);
			// Return mock response for demo
			const created: Award[] = awards.map((award, index) => ({
				...award,
				id: (Date.now() + index).toString(),
				createdAt: new Date().toISOString(),
				updatedAt: new Date().toISOString(),
			}));

			return {
				success: true,
				data: {
					created,
					count: awards.length,
				},
				message: `Import thành công ${awards.length} khen thưởng`,
			};
		}
	},

	// Export awards
	export: async (filters?: AwardFilters): Promise<ApiResponse<Award[]>> => {
		try {
			const response = await apiClient.get<Award[]>(`${config.endpoints.awards}/export`, filters);
			return response;
		} catch (error) {
			console.error("Error exporting awards:", error);
			// Return mock data for demo
			return {
				success: true,
				data: mockAwards,
				message: "Export dữ liệu thành công",
			};
		}
	},

	// Search public awards (for public search page)
	searchPublic: async (query: { cccd?: string; studentId?: string; awardNumber?: string }): Promise<ApiResponse<Award[]>> => {
		try {
			const response = await apiClient.get<Award[]>(`${config.endpoints.public.search}/awards`, query);
			return response;
		} catch (error) {
			console.error("Error searching awards:", error);
			// Return mock search results
			const results = mockAwards.filter((award) => {
				if (query.cccd && award.cccd === query.cccd) return true;
				if (query.studentId && award.studentId === query.studentId) return true;
				if (query.awardNumber && award.awardNumber === query.awardNumber) return true;
				return false;
			});

			return {
				success: true,
				data: results,
			};
		}
	},
};
